module.exports = __webpack_public_path__ + "img/confident-woman.421c89f9.png";